(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/charity-logo.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/charity-logo.js');


'use strict';

var _svs;
const {
  useState,
  useRef
} = React;
const {
  useAtom
} = jotai;
const {
  charityAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const cdn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2.replace('/content', '');
const CharityLogo = _ref => {
  let {
    isRemoveable = false
  } = _ref;
  const [charity, setCharity] = useAtom(charityAtom);
  const [isRemoved, setIsRemoved] = useState(false);
  const containerRef = useRef(null);
  if (!charity || isRemoved) {
    return null;
  }
  const handleCloseClick = () => {
    if (containerRef.current) {
      const tl = gsap.timeline({
        onComplete: () => {
          setIsRemoved(true);
          setCharity(null);
        }
      });
      tl.to(containerRef.current, {
        duration: 0.3,
        opacity: 0,
        scale: 0.7
      });
      tl.to(containerRef.current, {
        duration: 0.3,
        height: 0,
        padding: 0,
        margin: 0,
        ease: 'easeInOut'
      }, '<50%');
    }
  };
  if (isRemoveable) {
    return React.createElement("div", {
      className: "lp-charity-logo-container",
      ref: containerRef
    }, React.createElement(IconButton, {
      onClick: handleCloseClick
    }, React.createElement(Icon, {
      size: 100,
      icon: "close"
    })), React.createElement("img", {
      src: cdn + charity.logotypeId,
      alt: charity.name
    }));
  }
  return React.createElement("img", {
    src: cdn + charity.logotypeId,
    alt: charity.name
  });
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  CharityLogo
});

 })(window);